let path = "https://cms.vosmos.world";
if (process.env.NODE_ENV === "development") {
  path = "http://localhost:5013";
}
//let path = "http://localhost:5013";
export const method = {
  post: "post",
  put: "put",
  get: "get",
  delete: "delete",
};
export const basePath = path;
// export const basePath = "";
export const apiPath = basePath + "/api";
export const apiLoginUser = "/login";
export const apiLogutUser = "/logout";
export const apiGetUser = "/user";
export const apiRegisterUser = "/register";
export const apiBlogs = "/blogs";
export const apiUploadImage = "/upload";
export const apiWidgets = "/widgets";
export const apiCasestudy = "/casestudy";
export const apiCategories = "/categories";
export const apiGallery = "/gallery";
export const apiPrArticle = "/pr-article";
export const apiMenuArticle = "/menu-article";
